import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { DocumentService } from '../../../../../../services/document/document.service';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-templateTermination1',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './templateTermination1.component.html',
  styleUrls: ['./templateTermination1.component.css'],
})
export class TemplateTermination1 implements OnInit {
  currentStep = 1;

  contractor = {
    name: '',
    idType: 'CC',
    id: '',
  };

  contract = {
    contractNumber: '',
    contractObject: '',
    contractDuration: '',
    contractTerm: '',
    contractReason: '',
    contractClause: '',
    contractObservation: '',
  };

  liquidations = {
    liquidationsValue: '',
    liquidationsValueWords: '',
  };

  signature = {
    signaturePlace: '',
    signatureDate: '',
  };

  constructor( private router: Router, private route: ActivatedRoute,private http: HttpClient, private documentService: DocumentService)  {}

  
  ngOnInit(): void {
    const formId = this.route.snapshot.queryParamMap.get('formId');
    const menuId = this.route.snapshot.queryParamMap.get('menuId');
    if (!formId || !menuId) {
      return;
    }
  
    this.documentService.getFormData(formId, menuId).subscribe({
      next: (response) => {
        const formData = response.formData;
        this.populateFormData(formData);
      },
      error: (err) => {
        console.error('Error al recuperar formulario:', err);
        alert('No se pudo cargar el formulario.');
      }
    });
  }
  
  populateFormData(formData: any) {
    this.contractor = {
      id: formData.contractorId || '',
      name: formData.contractorName || '',  
      idType: formData.contractorIdType || 'CC',
    };
  
    this.contract = {
      contractNumber: formData.contractNumber || '',
      contractObject: formData.contractObject || '',
      contractDuration: formData.contractDuration || '',
      contractTerm: formData.contractTerm || '',
      contractReason: formData.contractReason || '',
      contractClause: formData.contractClause || '',
      contractObservation: formData.contractObservation || ''
    };
  
    this.liquidations = {
      liquidationsValue: formData.liquidationsValue || '',
      liquidationsValueWords: formData.liquidationsValueWords || ''
    };
  
    this.signature = {
      signaturePlace: formData.signaturePlace || '',
      signatureDate: formData.signatureDate || ''
    };
  }
  
    generateDocument() {
      const formData = {
        ...this.contractor,
        ...this.contract,
        ...this.liquidations,
        ...this.signature,
      };
    
      const menuId = '3';
    
      this.documentService.generateDocument(formData, menuId).subscribe({
        next: (res) => {
          console.log('Documento generado:', res);   
          if (res?.url) {
            const link = document.createElement('a');
            link.href = res.url;
            link.download = '';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } else {
            alert('Documento generado pero no se recibió una URL de descarga.');
          }
        },
        error: (err) => {
          console.error('Error al generar el documento:', err);
          alert('No se pudo generar el documento.');
        }
      });
    }
    

  goToNextStep(): void {
      localStorage.setItem(
        'formData',
        JSON.stringify({
          contractor: this.contractor,
          contract: this.contractor,
          liquidations: this.liquidations,
          signature: this.signature,
        })
      );
    if (this.currentStep < 2) {
      this.currentStep++;
      this.scrollToTop();
    }
  }

  goToPreviousStep(): void {
    const savedFormData = localStorage.getItem('formData');
    if (savedFormData) {
      const formData = JSON.parse(savedFormData);

      this.contractor = formData.contractor || this.contractor;
      this.contract = formData.contract || this.contract;
      this.liquidations = formData.liquidations || this.liquidations;
      this.signature = formData.signature || this.signature;
    }

    if (this.currentStep > 1) {
      this.currentStep--;
      this.scrollToTop();
    }
  }

  saveAsDraft() {
    const formData = {
      ...this.contractor,
      ...this.contract,
      ...this.liquidations,
      ...this.signature,
    };
  
    const menuId = '1';
  
    this.documentService.saveForm(formData, menuId).subscribe({
      next: (res) => {
        console.log('Formulario guardado como borrador:', res);
        alert('Formulario guardado correctamente.');
      },
      error: (err) => {
        console.error('Error al guardar el formulario:', err);
        alert('Ocurrió un error al guardar el formulario.');
      }
    });
  }

  clearLocalStorage(): void {
    localStorage.clear();
  }
  
  private scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
 
}


